(function () {
  function getVariantMap(card) {
    const productId = card.dataset.productId;
    const script = document.querySelector(`script[data-upsell-variant-map="${productId}"]`);
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function updateCardForSelection(card) {
    const data = getVariantMap(card);
    if (!data) return;
    const colorSelect = card.querySelector('[data-upsell-color]');
    const sizeSelect = card.querySelector('[data-upsell-size]');
    const color = colorSelect ? colorSelect.value : '';
    const size = sizeSelect ? sizeSelect.value : '';
    const key = `${color}|${size}`;
    const variant = data.variants[key];
    if (!variant) return;

    const priceEl = card.querySelector('[data-upsell-price]');
    const compareEl = card.querySelector('.cart-drawer__upsell-compare');
    const badgeEl = card.querySelector('[data-upsell-badge]');
    if (priceEl) priceEl.textContent = variant.price;
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price !== variant.price) {
        compareEl.textContent = variant.compare_at_price;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (badgeEl) {
      if (variant.savings_pct) {
        badgeEl.textContent = `Ahorra ${variant.savings_pct}%`;
        badgeEl.style.display = '';
      } else {
        badgeEl.style.display = 'none';
      }
    }
    const imageEl = card.querySelector('[data-upsell-image]');
    if (imageEl && variant.image) imageEl.src = variant.image;

    const addButton = card.querySelector('[data-upsell-add]');
    if (addButton) addButton.disabled = !variant.available;
  }

  function addToCart(card) {
    const data = getVariantMap(card);
    if (!data) return;
    const colorSelect = card.querySelector('[data-upsell-color]');
    const sizeSelect = card.querySelector('[data-upsell-size]');
    const color = colorSelect ? colorSelect.value : '';
    const size = sizeSelect ? sizeSelect.value : '';
    const key = `${color}|${size}`;
    const variant = data.variants[key];
    if (!variant || !variant.available) return;

    const addButton = card.querySelector('[data-upsell-add]');
    if (addButton) addButton.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variant.id, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json().then((json) => ({ ok: response.ok, json })))
      .then(({ ok, json }) => {
        if (!ok) throw new Error(json.description || 'No se pudo añadir el producto.');
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(json);
        }
      })
      .catch((error) => {
        window.alert(error.message || 'No se pudo añadir el producto.');
      })
      .finally(() => {
        if (addButton) addButton.removeAttribute('disabled');
      });
  }

  function initUpsell(root) {
    if (!root || root.dataset.upsellInitialized === 'true') return;
    root.dataset.upsellInitialized = 'true';

    const track = root.querySelector('[data-upsell-track]');
    const prevBtn = root.querySelector('[data-upsell-prev]');
    const nextBtn = root.querySelector('[data-upsell-next]');

    if (track && prevBtn && nextBtn) {
      const scrollAmount = () => track.clientWidth;
      prevBtn.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
      nextBtn.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
    }

    root.querySelectorAll('[data-upsell-card]').forEach((card) => {
      updateCardForSelection(card);
      card.querySelectorAll('[data-upsell-color], [data-upsell-size]').forEach((select) => {
        select.addEventListener('change', () => updateCardForSelection(card));
      });
      const addButton = card.querySelector('[data-upsell-add]');
      if (addButton) {
        addButton.addEventListener('click', () => addToCart(card));
      }
    });
  }

  // .drawer__footer sits absolutely-positioned over the bottom of the
  // drawer (see component-cart-extras.css), pinned there instead of
  // floating above leftover space. Let the region (items + upsell) grow to
  // fill the space actually available above the footer — combined with
  // "Añade y ahorra" having margin-top:auto (also in the CSS file), any
  // slack shows up as a gap right after the cart items, and the upsell
  // card stays right above the footer instead of floating with dead space
  // below it. If everything together is taller than that, this same region
  // simply becomes the one scrollbar for the whole thing.
  function capScrollRegion() {
    const region = document.querySelector('.cart-drawer__scroll-region');
    const footer = document.querySelector('.drawer__footer');
    if (!region) return;
    const availableAboveFooter = footer
      ? footer.getBoundingClientRect().top - region.getBoundingClientRect().top
      : null;
    region.style.maxHeight = availableAboveFooter != null ? Math.max(availableAboveFooter, 0) + 'px' : '';
  }

  function initAll() {
    document.querySelectorAll('.cart-drawer__upsell').forEach(initUpsell);
    requestAnimationFrame(capScrollRegion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('resize', capScrollRegion);

  // The cart drawer's inner HTML gets replaced whenever the cart updates
  // (renderContents in cart-drawer.js), which wipes our init flag along
  // with the nodes — so re-run whenever that happens.
  const observer = new MutationObserver(() => initAll());
  document.addEventListener('DOMContentLoaded', () => {
    const cartDrawerEl = document.getElementById('CartDrawer');
    if (cartDrawerEl) observer.observe(cartDrawerEl, { childList: true, subtree: true });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const cartDrawerToggle = document.querySelectorAll('a[href="#cart-drawer"], button[aria-controls="CartDrawer"], .header__icon--cart');
    cartDrawerToggle.forEach((el) => {
      el.addEventListener('click', () => requestAnimationFrame(() => requestAnimationFrame(capScrollRegion)));
    });
  });
})();
